import React, { useContext } from 'react';
import { styled, useTheme } from '@mui/material/styles';
import {AppBar, Toolbar, useMediaQuery} from '@mui/material';
import { format } from 'date-fns';
import { Link } from 'react-router-dom';
// import { useMsal } from '@azure/msal-react';
import { MahiContext, mahiTokenFromMahiContext } from '../state/MahiContext';

const PREFIX = 'ApplicationFooter';

const classes = {
  footerBar: `${PREFIX}-footerBar`,
};

const WhiteLink = styled(Link)((props) => ({
    textDecoration: 'none',
    color: 'white',
}))


const StyledAppBar = styled(AppBar)(({theme}) => ({
  [`&.${classes.footerBar}`]: {
    backgroundColor: env === 'production' ? theme.palette.primary.main : theme.palette.nonprod.main,
    display: 'flex',
    // flexDirection: 'row',
    justifyContent: 'space-between',
    '& span': {
        flexGrow: 0,
        marginRight: '8px',
    },
    '& span.login_name': {
        flexGrow: 1,
        marginRight: '8px',
        textAlign: 'right',
    },
  },

}));

const env = process.env.REACT_APP_ENV;

export default function ApplicationFooter() {
  // const theme = useTheme();
  // const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  // const { accounts } = useMsal();
  // const firstAccount = accounts && accounts[0]
  const mahiContext = useContext(MahiContext)
  // console.log('UserProfile mahiContext', mahiContext)
  const mahiTokenObject = mahiTokenFromMahiContext(mahiContext)


  const theme = useTheme()
  const isSmallerThanMedium = useMediaQuery(theme.breakpoints.down('md'));

  const footerLeft = isSmallerThanMedium ? 'Mahi' : 'Mahi Copyright Northpower ' + format(new Date(), 'yyyy')

  return (
    <StyledAppBar position='static' className={classes.footerBar}>
        <Toolbar>
            <span>{footerLeft}</span>
            <span className="login_name">
              <WhiteLink to="/profile" title="Go to Profile Page">
                {mahiTokenObject?.name} ({mahiTokenObject.email})
              </WhiteLink>
            </span>
            {/* <span>{isMobile ? 'Mobile' : 'Desktop'}</span> */}
            {/* <span>NODE_ENV: {process.env.NODE_ENV}</span> */}
            {/* <span>REACT_APP_ENV: {process.env.REACT_APP_ENV}</span> */}
            {/* <span>REACT_APP_SENTRY_RELEASE: {process.env.REACT_APP_SENTRY_RELEASE}</span> */}
        </Toolbar>
    </StyledAppBar>
  );
}